<breadcrumbs
  [breadcrumbs]="[{ label: 'ADMIN', url: '/admin' }, { label: 'USERS' }]"
></breadcrumbs>

<page-header title="USERS"></page-header>

<app-table
  [isLoading]="isLoading"
  [totalItems]="state.get('total')"
  [totalResults]="state.get('filtered')"
  [itemsPerPage]="getPagination('page_size')"
  [rows]="state.get('data')"
  [currentPage]="getPagination('page')"
  [sort]="getPagination('sort')"
  [orderBy]="getPagination('order_by')"
  [columns]="columns"
  [filters]="filters"
  (onFilterChange)="handleFilterChange($event)"
  [showFilter]="true"
  [showReload]="true"
>
  <ng-template #addonLeft>
    <div class="buttons m-0">
      <a
        [routerLink]="['create']"
        class="button is-small is-info"
        translationEditableDirective="CREATE_USER"
        >{{ 'CREATE_USER' | translate }}</a
      >
    </div>
  </ng-template>

  <ng-template let-row="row" #suspendedColumn>
    <span
      [translationEditableDirective]="row.get('suspended') ? 'YES' : 'NO'"
      >{{ (row.get('suspended') ? 'YES' : 'NO') | translate }}</span
    >
  </ng-template>

  <ng-template let-row="row" #twoFactorColumn>
    <span
      [translationEditableDirective]="row.get('twoFactorAuth') ? 'YES' : 'NO'"
      >{{ (row.get('twoFactorAuth') ? 'YES' : 'NO') | translate }}</span
    >
  </ng-template>

  <ng-template let-row="row" #rolesColumn>
    <span
      [options]="{ placement: 'left' }"
      [tooltip]="getJoinedRoles(row.get('roles'))"
      tooltipClass="white-tooltip"
      theme="light"
      [animationDuration]="0"
      [hideDelay]="0"
      [display]="row.get('roles').size > 1"
    >
      {{ row.getIn(['roles', 0, 'title']) }}
      <span style="font-weight: bold" *ngIf="row.get('roles').size > 1"
        >(+{{ row.get('roles').size - 1 }})</span
      >
    </span>
  </ng-template>

  <ng-template let-row="row" #actionsColumn>
    <div class="buttons">
      <a
        [routerLink]="[row.get('id'), 'update']"
        class="button is-small"
        translationEditableDirective="UPDATE"
        >{{ 'UPDATE' | translate }}</a
      >
      <alert
        #deleteAlert
        (confirm)="deleteUser(row.get('id'))"
        titleTrnKey="ARE_YOU_SURE"
        textTrnKey="YOU_WONT_BE_ABLE_TO_REVERT_THIS"
      />
      <button
        class="button is-danger is-small"
        (click)="deleteAlert.fire()"
        translationEditableDirective="DELETE"
      >
        {{ 'DELETE' | translate }}
      </button>
    </div>
  </ng-template>
</app-table>
